import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CommonService } from '../../common/services/common.service';
import { StatisticsDTO } from '../../common/types/statistics';
import { TranslateService } from '@ngx-translate/core';
import { colors, dashboardChartConfig } from '../../app.config';
import { SettingsDTO } from '../../common/types/settings';
import { isInOpeningHours } from '../../common/utils';

@Component({
  selector: 'app-live-view-charts',
  templateUrl: './live-view-charts.component.html',
  styleUrl: './live-view-charts.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LiveViewChartsComponent implements OnChanges {
  @Input() liveViewChartsData: StatisticsDTO;
  @Input() settingsData: SettingsDTO;
  charts: any[] = [];

  constructor(private commonService: CommonService,
              private translateService: TranslateService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.liveViewChartsData && (changes['liveViewChartsData'] || changes['settingsData'])) {
      this.charts = [];
      this.getAverageOccupancyInADayChartConfig();
      this.getNewVsReturningVisitorsChartConfig();
    }
  }

  getAverageOccupancyInADayChartConfig() {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    let filteredTableRows = this.liveViewChartsData.table.rows
      .filter(item => new Date(item.periodStart) >= startOfToday)
      .reverse();
    if (this.settingsData?.openTime && this.settingsData?.closeTime) {
      filteredTableRows = filteredTableRows.filter(item => isInOpeningHours(this.settingsData, item.periodStart));
    }
    const occupancyData = filteredTableRows.map(item => item.peakOccupancy);
    const labels = filteredTableRows.map(item => item.periodStart.substring(5, 10) + ' ' + item.periodStart.substring(11, 16));
    const data = {
      labels: labels,
      datasets: [
        {
          type: 'line',
          label: this.translateService.instant('STATISTICS.OCCUPANCY_INSIDE'),
          data: occupancyData,
          borderColor: colors.secondary,
          backgroundColor: colors.primary,
          pointBorderColor: colors.secondary,
          pointBackgroundColor: colors.primary,
          tension: 0.2,
          fill: false
        }
      ]
    };
    this.charts.push({ type: 'line', data: data, options: dashboardChartConfig });
  }

  getNewVsReturningVisitorsChartConfig() {
    const chartData = this.commonService.getNewVsReturningVisitorsChartConfig(this.liveViewChartsData.newVsReturning['visits']);
    this.charts.push({ data: chartData.data, legendData: chartData.legendData });
  }

  protected readonly colors = colors;
}
